import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// Ready translated locale messages
const messages = {
  pt: {
    pageLogin: {
      title: 'Conecte-se',
      labelPassword: 'Password',
      placeholdEmail: 'Digite aqui o seu email',
      placeholdPassword: 'Digite aqui a sua password',
      mensagem: 'Esqueceu a password?',
      cadastrar: 'Registe-se',
    },
    pageCadastro: {
      labelPassword: 'Password',
      labelConfirmPassword: 'Confirme a sua password',
      tooltipAba: 'Ver num novo separador',
      labelDestrito: 'Distrito',
    },
    pageProfile: {
      btnSenha: 'Alterar Password',
      labelDestrito: 'Distrito',
      titleContato: 'Contactos',
      titleEmergencia: 'Contactos de Emergência',
    },
    pageEditProfile: {
      btnSalvar: 'Guardar',
    },
    pageSenha: {
      title: 'Esqueci a password',
    },
    pageConsulta: {
      titleContato: 'Contactos',
    },
    pageCreateAgenda: {
      btnSalvar: 'Guardar',
    },
  },
  'pt-BR': {
    pageLogin: {
      title: 'Entrar',
      labelPassword: 'Senha',
      placeholdEmail: 'Digite aqui o seu email',
      placeholdPassword: 'Digite aqui a sua senha',
      mensagem: 'Esqueceu a senha?',
      cadastrar: 'Cadastrar',
    },
    pageCadastro: {
      labelPassword: 'Senha',
      labelConfirmPassword: 'Confirme a sua Senha',
      tooltipAba: 'Abre em uma nova aba',
      labelDestrito: 'Estado',
    },
    pageProfile: {
      btnSenha: 'Alterar Senha',
      labelDestrito: 'Estado',
      titleContato: 'Contatos',
      titleEmergencia: 'Contatos emergencial',
    },
    pageEditProfile: {
      btnSalvar: 'Salvar',
    },
    pageSenha: {
      title: 'Esqueci a senha',
    },
    pageConsulta: {
      titleContato: 'Contatos',
    },
    pageCreateAgenda: {
      btnSalvar: 'Salvar',
    },
  },
};

// const userLang = navigator.language || navigator.userLanguage;
const user = JSON.parse(localStorage.getItem('user-data'));
let language;
if (user != null) language = user.language;

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: language || 'pt', // set locale
  fallbackLocale: 'pt',
  formatFallbackMessages: true,
  messages, // set locale messages
});

export default i18n;
